import { getServerRequest, postServerRequest, deleteServerRequest } from '../../../services/serverRequest.service';
import { store } from '@/store/store';
const httpURL = store.getters.httpURL;

export async function obtenerIntegrantesCursoService(idCurso) {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/curso/campus/integrantes/${idCurso}`;
    return await getServerRequest(url, config);
}

export async function blockIntegranteCursoService(idCurso, idUsuario) {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/curso/campus/integrantes/block/${idCurso}/${idUsuario}`;
    return await getServerRequest(url, config);
}

export async function eliminarIntegranteService(data) {
    const token = store.getters.sessionToken;
    const config = { headers: { token } };
    const url = `${httpURL}/curso/campus/integrantes/eliminar/${data.idCurso}/${data.idIntegrante}`;
    return await deleteServerRequest(url, config);
}